import { IBannerDTO, IBannerParams } from "../banners.t";
import jsonParse from "../../../utils/jsonParse";
import { BANNER_BEHAVIORS_AFTER_CLOSE } from "../bannersConstants";

function parseBannerAttributeParamsOnInit(banner: IBannerDTO): IBannerParams {
    const params: IBannerParams = jsonParse(banner.params, {}) || {}
    const behaviorAfterClose = banner.behavior_after_close;

    return Object.entries(params).reduce<IBannerParams>((accumulator, [location, locationParams]) => {
        const closedAt = locationParams.closed_at;
        accumulator[location] = {
            ...locationParams,
            closed_at: behaviorAfterClose === BANNER_BEHAVIORS_AFTER_CLOSE.OPEN_NEXT_DAY ? closedAt : undefined,
        };
        return accumulator;
    }, {});
}

export default parseBannerAttributeParamsOnInit;
